// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"916a6ec3","198":"c1788d3b","433":"7601c9e1","445":"48e61dc6","554":"ecddf760","618":"87ff4104","908":"c029be0a","988":"741b379f","996":"ed937923"}[chunkId] + ".chunk.js";
};